import { render, staticRenderFns } from "./CopyCard.vue?vue&type=template&id=3adfcb58&scoped=true&"
import script from "./CopyCard.vue?vue&type=script&lang=js&"
export * from "./CopyCard.vue?vue&type=script&lang=js&"
import style0 from "./CopyCard.vue?vue&type=style&index=0&id=3adfcb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfcb58",
  null
  
)

export default component.exports